export const phoneVerificationUrl = '/users/phone-verification/';
export const usersDirectoryUrl = '/users/users-directory/';

export const loginUrl = '/login/';
export const signupUrl = '/signup/';
export const oldBrowserUrl = '/old-browser/';

export const formsGalleryUrl = '/forms-gallery/';
